import {ChipType} from "@bounce/shared/ui";

type BlockedStatusChip = {label: string; variant: ChipType["variant_"]};

const blockedStatusChips: Record<string, BlockedStatusChip> = {
  active_dispute: {label: "Dispute open", variant: "warning"},
  statute_of_limitations: {label: "Statute of limitations", variant: "warning"},
  account_closed: {label: "Closed", variant: "error"},
  creditor_recalled: {label: "Recalled by creditor", variant: "error"},
  bankruptcy: {label: "Bankruptcy", variant: "error"},
  fraud: {label: "Fraud reported", variant: "warning"},
  legal_collection: {label: "Legal collection", variant: "warning"},
};

export const getBlockedStatusChip = (reason: string): BlockedStatusChip | undefined => blockedStatusChips[reason];
